// import React from "react";

// function ComponentDetails({ object }) {
//   return (
//     <div className="border rounded  p-2 max-w-3xl mx-auto">
//       <h6 className="text-lg font-semibold text-gray-700 mb-4">
//         Details - Component
//       </h6>
//       <hr />
//       <div className="">
//         <p className="m-0">
//           <strong className="font-medium">Item Name :</strong>{" "}
//           {object?.component?.itemName}
//         </p>
//         <p className="m-0">
//           <strong className="font-medium">Quantity :</strong> {object?.quantity}
//         </p>
//         <p className="m-0">
//           <strong className="font-medium">Unit of Measurement :</strong>{" "}
//           {object?.component?.uom?.name}
//         </p>
//         <p className="m-0">
//           <strong className="font-medium">Date Created :</strong>{" "}
//           {new Intl.DateTimeFormat("en-US", {
//             year: "numeric",
//             month: "long",
//             day: "numeric",
//             hour: "numeric",
//             minute: "2-digit",
//             hour12: true,
//           }).format(new Date(object?.created))}
//         </p>
//       </div>
//     </div>
//   );
// }

// export default ComponentDetails;

import React from "react";

function ComponentDetails({ object }) {
  return (
    <div className="container">
      <div className="card shadow-sm border-0">
        {/* Header */}
        <div
          className="card-header bg-gradient text-white py-3"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          <h5 className="mb-0 fw-semibold">Component Details</h5>
        </div>

        {/* Content */}
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Item Name */}
            <div className="col-md-6">
              <div className="mb-0">
                <label
                  className="text-muted text-uppercase fw-semibold mb-2"
                  style={{ fontSize: "0.75rem", letterSpacing: "0.5px" }}
                >
                  Item Name
                </label>
                <p className="mb-0 fs-6 fw-medium text-dark">
                  {object?.component?.itemName || "—"}
                </p>
              </div>
            </div>

            {/* Quantity */}
            <div className="col-md-6">
              <div className="mb-0">
                <label
                  className="text-muted text-uppercase fw-semibold mb-2"
                  style={{ fontSize: "0.75rem", letterSpacing: "0.5px" }}
                >
                  Quantity
                </label>
                <p className="mb-0 fs-6 fw-medium text-dark">
                  {object?.quantity || "—"}
                </p>
              </div>
            </div>

            {/* Unit of Measurement */}
            <div className="col-md-6">
              <div className="mb-0">
                <label
                  className="text-muted text-uppercase fw-semibold mb-2"
                  style={{ fontSize: "0.75rem", letterSpacing: "0.5px" }}
                >
                  Unit of Measurement
                </label>
                <p className="mb-0 fs-6 fw-medium text-dark">
                  {object?.component?.uom?.name || "—"}
                </p>
              </div>
            </div>

            {/* Date Created */}
            <div className="col-md-6">
              <div className="mb-0">
                <label
                  className="text-muted text-uppercase fw-semibold mb-2"
                  style={{ fontSize: "0.75rem", letterSpacing: "0.5px" }}
                >
                  Date Created
                </label>
                <p className="mb-0 fs-6 fw-medium text-dark">
                  {object?.created
                    ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      }).format(new Date(object.created))
                    : "—"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComponentDetails;
